import {
  VoENextActionOwner,
  VoENextActionOwnerLabels,
  VoENextActionReason,
  VoENextActionReasonLabels,
} from 'src/graphql/types/verificationOfEmployments'

const OWNER_ORDER: VoENextActionOwner[] = [
  VoENextActionOwner.AUTOMATED,
  VoENextActionOwner.MANUAL,
]

const REASON_ORDER: VoENextActionReason[] = [
  VoENextActionReason.REVIEW_RESPONSE,
  VoENextActionReason.PLATFORM,
  VoENextActionReason.FAX,
  VoENextActionReason.EMAILS_EXHAUSTED,
  VoENextActionReason.CALLS_EXHAUSTED,
  VoENextActionReason.WRONG_NUMBER,
  VoENextActionReason.NO_CONTACT_INFO,
  VoENextActionReason.DO_NOT_CONTACT,
  VoENextActionReason.NOT_A_CARRIER,
  VoENextActionReason.CURRENT_EMPLOYER,
]

/** The two owners: enough for a column-header dropdown. */
export const NEXT_ACTION_OWNER_OPTIONS: { label: string; value: string }[] =
  OWNER_ORDER.map((value) => ({
    label: VoENextActionOwnerLabels[value].label,
    value,
  }))

/** Owners, then every reason: the Filters-menu list. */
export const NEXT_ACTION_FILTER_OPTIONS: { label: string; value: string }[] = [
  ...NEXT_ACTION_OWNER_OPTIONS,
  ...REASON_ORDER.map((value) => ({
    label: VoENextActionReasonLabels[value].label,
    value,
  })),
]

const OWNER_VALUES = new Set<string>(OWNER_ORDER)
const REASON_VALUES = new Set<string>(REASON_ORDER)

export interface NextActionQueryFilters {
  nextActionOwner?: VoENextActionOwner[]
  nextActionReason?: VoENextActionReason[]
}

/**
 * Maps the selected Next action options to the list-query filters. The API
 * OR-combines owners and reasons, so "Manual" plus "Wrong number" is every
 * row a person holds. Unknown values (a hand-edited URL) are dropped;
 * nothing selected means no filter.
 */
export const buildNextActionFilters = (
  selected: string[] | null | undefined
): NextActionQueryFilters => {
  const values = selected ?? []
  const owners = values.filter((v) =>
    OWNER_VALUES.has(v)
  ) as VoENextActionOwner[]
  const reasons = values.filter((v) =>
    REASON_VALUES.has(v)
  ) as VoENextActionReason[]
  return {
    nextActionOwner: owners.length ? owners : undefined,
    nextActionReason: reasons.length ? reasons : undefined,
  }
}
